<script setup lang="ts">
import type { AreaWithConsumptionSankey } from '~/components/ui/chart/AreaSankey.vue';

// Store
const { loadZoneData } = useZoneService();
const { zoneResponse, loading } = storeToRefs(zoneStore());
const { setAreaId } = exploreStore();

const areaWithConsumption = computed(() => {
  if (!zoneResponse.value?.areas) return [];
  return zoneResponse.value?.areas.map((area) => {
    return {
      id: area.id,
      name: area.label,
      parent_id: area.parent_id,
      consumption: area.consumption.quantity,
      top_level_percentage: area.top_level_percentage,
      parent_percentage: area.parent_percentage,
    };
  });
});

const handleNodeClick = async (node: AreaWithConsumptionSankey) => {
  await setAreaId(node.id);
  await loadZoneData();
};
</script>
<template>
  <ui-chart-area-sankey :loading="loading" :area-with-consumption="areaWithConsumption" clickable @node-click="handleNodeClick" />
</template>
